import React from "react";
import { Modal, Descriptions, Button, message } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import copy from "copy-to-clipboard";

export default function RegisterSuccessModal({ onClose, info, visible }) {
    function okHandle() {
        onClose();
    }

    function onCancelHandle() {
        onClose();
    }

    const copyInfo = () => {
        copy(`用户名:${info.userName} \n手机号:${info.mobile}\n`);
        message.success("复制成功！");
    };
    return (
        <Modal
            title={"创建成功"}
            visible={visible}
            centered
            maskClosable={false}
            destroyOnClose={true}
            footer={[
                <Button key="back" type="primary" onClick={copyInfo}>
                    一键复制
                </Button>,
                <Button key="submit" type="primary" onClick={okHandle}>
                    知道了
                </Button>,
            ]}
            onOk={() => okHandle()}
            onCancel={() => onCancelHandle()}>
            <div>
                <div style={{ margin: "10px 0" }}>
                    <CheckCircleFilled style={{ color: "#52C41A" }} />
                    您已成功创建员工帐号，请联系企业管理员添加权限
                </div>
                <Descriptions colon={3}>
                    <Descriptions.Item label="用户名" span={3}>
                        {info.userName}
                    </Descriptions.Item>
                    <Descriptions.Item label="手机号" span={3}>
                        {info.mobile}
                    </Descriptions.Item>
                </Descriptions>
            </div>
        </Modal>
    );
}
